<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#333333" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.96034 12L14.6141 17.6538L15.668 16.6L11.068 12L15.668 7.39998L14.6141 6.34616L8.96034 12Z" />
    </svg>
</template>